import React, { useState } from "react";

import { FormContainer } from "./styles";
import { makeStyles } from "@mui/styles";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import { Typography } from "@mui/material";
import { useHistory } from "react-router-dom";
import * as PasswordService from "../../../services/password";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import CircularProgress from "@mui/material/CircularProgress";
import { ReactComponent as Logo } from "../../../assets/img/OiCarLogoDark.svg";

const useStyles = makeStyles({
    fields: {
        width: 300,
    },
});

const PassRecoverSendEmail = ({ inputs, setInputs, setFormStep }) => {
    const classes = useStyles();
    const history = useHistory();
    const [loading, setLoading] = useState(false);

    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setInputs((values) => ({ ...values, [name]: value }));
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        PasswordService.sendEmail(inputs.email)
            .then(() => {
                setLoading(false);
                setFormStep("codeValidation");
            })
            .catch((error) => {
                if (error.response.status === 500) {
                    alert("Erro ao enviar o email, usuário não encontrado!");
                }
            });
    };

    return (
        <FormContainer>
            <form onSubmit={handleSubmit}>
                <Grid container direction="column" rowSpacing={2} justifyContent="center" alignContent="center" marginTop={3}>
                    <Grid item display="grid" justifyItems="center">
                        <Logo style={{ width: "120px", height: "50px" }} />
                    </Grid>
                    <Grid item marginTop={1} marginLeft={15}>
                        {loading === false && <LockOpenIcon htmlColor="#666666" style={{ height: "50px", width: "50px" }} />}
                        {loading === true && <CircularProgress style={{ height: "50px", width: "50px", color: "#666666" }} />}
                    </Grid>
                    <Grid item justifyItems="center">
                        <Typography fontSize={16} fontWeight="bold">
                            Recuperar Senha!
                        </Typography>
                        <Typography fontSize={16}>Para continuar, informe seu email.</Typography>
                    </Grid>
                    <Grid item marginTop={2}>
                        <TextField name="email" type="email" required label="E-mail" variant="outlined" className={classes.fields} onChange={handleChange} />
                    </Grid>
                    <Grid item marginTop={3}>
                        <Button variant="contained" type="submit" style={{ width: 300, height: 50 }}>
                            Próximo
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button variant="text" style={{ width: 300, height: 30 }} onClick={() => history.push("/login")}>
                            Voltar
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </FormContainer>
    );
};

export default PassRecoverSendEmail;
